import json from './init.json';

export default {
  // Stato auth derivato dallo SDK Logto (sincronizzato da tryLogin).
  setAuthenticated(state, value) {
    state.authenticated = value;
    state.didAutoLogout = false;
  },
  setAutoLogout(state) {
    state.didAutoLogout = true;
  },
  reset(state) {
    const s = json[0];
    Object.keys(s).forEach(key => {
      state[key] = s[key]
    })
  }
};
